<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <i18n-t keypath="kudosReceivedNotification.title" tag="span">
        <template #from>
          <strong>{{ notification.data.from_user || $t('kudosReceivedNotification.someone') }}</strong>
        </template>
      </i18n-t>
      <template v-if="notification.data.row_title">
        · <strong>{{ notification.data.row_title }}</strong>
      </template>
    </div>
    <div
      v-if="notification.data.message"
      class="notification-panel__notification-content-desc"
    >
      “{{ notification.data.message }}”
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'KudosReceivedNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
